import { useTheme } from "@/hooks/useTheme";
import { Stack } from "expo-router";

export default function ReportsLayout() {
  const { colors } = useTheme();
  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: {
          backgroundColor: colors.background,
        },
      }}
    >
      <Stack.Screen name="index" />
      <Stack.Screen name="(injury)" />
      <Stack.Screen name="(pay-discrepancy)" />
    </Stack>
  );
}
